import { useEffect, useState } from "react";
import { BellRing, BellOff } from "lucide-react";
import { toast } from "sonner";
import { pushSupported, currentSubscription, enablePush, disablePush } from "@/lib/push";

export const PushToggle = ({ testid = "push-toggle", className = "" }) => {
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);
  const supported = pushSupported();

  useEffect(() => {
    if (!supported) return;
    currentSubscription().then(s => setOn(!!s && Notification.permission === "granted")).catch(() => {});
  }, [supported]);

  const toggle = async () => {
    setBusy(true);
    try {
      if (on) { await disablePush(); setOn(false); toast.success("Notifications turned off"); }
      else { await enablePush(); setOn(true); toast.success("You'll be notified when creators you follow post"); }
    } catch (e) { toast.error(e.message || "Couldn't update notifications"); }
    finally { setBusy(false); }
  };

  if (!supported) return null;
  const Icon = on ? BellRing : BellOff;
  return (
    <button onClick={toggle} disabled={busy} data-testid={testid} aria-pressed={on}
      className={`jx-btn h-9 px-4 rounded-full font-semibold text-sm inline-flex items-center gap-2 border ${on ? 'border-[#00E7FF]/60 bg-[#00E7FF]/10 text-[#00E7FF]' : 'border-white/15 hover:bg-white/5'} ${className}`}>
      <Icon size={14}/> {busy ? "…" : on ? "Notifications on" : "Enable notifications"}
    </button>
  );
};
